import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import authContext from '../context/auth/authContext';

export const PrivateRoutes = ({ children }) => {
    const AuthContext = useContext(authContext);
    const { autenticado } = AuthContext;

    return autenticado
        ? children
        : <Navigate to="/login" />
}